import React from "react";
import { Link } from "@quintype/components";

import FourIcon from "../atoms/FourIcon";
import NotFoundIcon from "../atoms/NotFoundIcon";

import "./not-found.m.css";

const NotFoundPage = () => (
  <React.Fragment>
    <div styleName="wrapper">
      <div styleName="status">
        <FourIcon />
        <NotFoundIcon />
        <FourIcon />
      </div>
      <h1 styleName="headline">কোন ফলাফল পাওয়া যায়নি</h1>
      <p styleName="no-results-brief">
        আপনি যে বিষয়টি অনুসন্ধান করছেন তা খুজে পাওয়া যায়নি। বিষয়টি সম্ভবত প্রথম আলোর সাথে সংশ্লিষ্ট নয় অথবা আপনি
        ভুলভাবে অনুসন্ধান করছেন। অনুগ্রহ করে আপনার অনুসন্ধান বিষয়টি সম্বন্ধে নিশ্চিত হোন।
      </p>
      <div styleName="cover-button">
        <Link href="/">প্রচ্ছদ</Link>
      </div>
    </div>
  </React.Fragment>
);

export { NotFoundPage };
